import { render } from "./MainSelector.vue?vue&type=template&id=644e2cca&ts=true"
import script from "./MainSelector.vue?vue&type=script&lang=ts"
export * from "./MainSelector.vue?vue&type=script&lang=ts"

import "./MainSelector.vue?vue&type=style&index=0&id=644e2cca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
